import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql`
  mutation AnalyzeYield($params: AnalyzeYieldInput!) {
    analyzeYield(params: $params) {
      rasterUrl
    }
  }
`;

export interface YieldAnalysisParams {
  sourceRasters: string[];
  binCount?: number;
}

export type YieldAnalysisResult = {
  rasterUrl: string;
  vectorUrl: string;
};

interface Renders {
  execute: (params: YieldAnalysisParams) => void;
  processing: boolean;
}

type ChildrenFn = (renders: Renders) => React.ReactNode;

interface Props {
  onCompleted: (result: YieldAnalysisResult) => void;
  onError?: (error: any) => void;
  children: ChildrenFn;
}

const AnalyzeYieldProvider: React.StatelessComponent<Props> = (
  props: Props
) => {
  return (
    <AuthorizedMutation
      mutation={GQL}
      onCompleted={data => props.onCompleted(data.analyzeYield)}
      onError={props.onError}
    >
      {(mutateFn, result) =>
        props.children({
          processing: result.loading,
          execute: params => mutateFn({ variables: { params } })
        })
      }
    </AuthorizedMutation>
  );
};

export default AnalyzeYieldProvider;



// WEBPACK FOOTER //
// ./src/providers/AnalyzeYieldProvider.tsx